// export const APIURL="http://localhost:3000";

// export const APIURL="http://192.168.1.26:3000";
export const APIURL="https://yahyalifirmalar.com/service";
export const IMAGEURL_PREFIX="https://yahyalifirmalar.com/service/";
// export const IMAGEURL_PREFIX="https://directorytestbucket.s3.eu-west-2.amazonaws.com/";
//export const APIURL="https://directoryservice.herokuapp.com"

export const GET_CATEGORIES=APIURL+"/categories";
export const ADD_CATEGORY_URL=APIURL+"/category/add/";
export const UPDATE_CATEGORY_URL=APIURL+"/category/update/";
export const ADD_BUSINESS_URL=APIURL+"/business/add/";

export const ADD_BUSINESS_USER_URL=APIURL+"/business/user/add/";

export const ADD_SUBCATEGORY_URL=APIURL+"/subcategory/add/";
export const UPDATE_SUBCATEGORY_URL=APIURL+"/subcategory/update/";
export const DELETE_SUBCATEGORY_URL=APIURL+"/subcategory/delete/";

export const GET_BUSINESS_LIST_BYSUBCATEGORY=APIURL+"/business/?subCatId="
export const GET_BUSINESS_BYCAT_SUBCAT=APIURL+"/business/get/";
export const UPDATE_BUSINESS_URL=APIURL+"/business/update/";
export const DELETE_CATEGORY_URL=APIURL+"/category/delete/"
export const DELETE_BUSINESS_URL=APIURL+"/business/hide/"

export const DELETEFULL_BUSINESS_URL=APIURL+"/business/delete/"

export const LOGIN_URL=APIURL+"/user/login";

export const GET_MESSAGES_URL=APIURL+"/messages";
export const MESSAGE_SEND_URL=APIURL+"/message/send";


export const GET_BUSINESS_LIST_ADMIN=APIURL+"/businesslist/admin/";
